/**
 * Dialog to delete a given device from a production device group
 *
 * Pass the device in as the view's model, eg.
 *
 * var dialog = new DeleteProductionDeviceDialog({ model: device });
 */
import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/delete-production-device-dialog.hbs';

    var alertCh = Radio.channel('alerts');
    
    var UNBLESS_KEY_LENGTH = 32;
    var success_tmpl = Handlebars.compile('Successfully deleted device {{id}}. You will lose access to this device\'s information upon leaving or refreshing this page.');
    var strings = {
        unbless_key_help: 'What is the Unbless Key?\n\nThe key a customer must enter to remove the Global Bond from a specified device before a device can be deleted.\n\nTo get an Unbless Key, contact support@electricimp.com.'
    };

    var View = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        ui: {
            form: 'form',
            submit: 'button.submit',
            key: 'input[name=unbless-key]',
            help: 'i.help'
        },
        events: {
            'submit @ui.form': 'on_submit',
            'keyup @ui.key': 'set_submit_state'
        },
        initialize: function() {
            this.destroyOnClose();
            _.bindAll(this, 'on_success', 'error');
        },
        /**
         * Handle a form submission
         *
         * @param DOMEvent
         */
        on_submit: function(e) {
            e.preventDefault();
            var key = this.ui.key.val();
            var error;
            var group = this.model.rel.get('devicegroup');
            if (!group) {
                error = 'Device not assigned to a Device Group';
            }
            if (error) {
                return this.error(error);
            }
            // In order to delete a production device, we must provide 
            // an unbless key, obtained out-of-band. Ideally this sort of
            // API-level header munging should be handled by the model layer, 
            // but in the interest of getting this out quickly, we'll write 
            // the headers in here. Consider it a TODO.
            group.unassign([this.model], {
                headers: {
                    'X-Electricimp-Key': key
                }
            })
                .done(this.on_success)
                .fail(this.error)
            ;
        },
        on_success: function() {
            alertCh.request('showAlert', {
                message: success_tmpl({ id: this.model.id }),
                messageType: 'warning',
                timeout: 0
            });
            this.closeDialog();
        },
        error: function (error) {
            var err_string = 'Unknown error';
            if (_.isString(error)) {
                err_string = error;
            } else {
                try {
                    err_string = error.responseJSON.errors.map(function(e) {
                        return [e.title, e.detail].join(': ');
                    }).join('; ');
                } catch (e) { console.error(e); }
            }
            DialogInterface.showAlert.call(this, 'alert-danger', err_string);
        },
        /**
         * Check the value of the unbless key input field. If it is not empty,
         * enable the submit button.
         *
         */
        set_submit_state: function() {
            var val = this.ui.key.val();
            this.ui.submit.attr('disabled', !(val && val.length >= UNBLESS_KEY_LENGTH));
        },
        templateContext: function() {
            return {
                s: strings,
                // Necessary because bootstrap styles hide some of the
                // text if we set the input field to exactly the number of
                // characters we need
                unbless_key_size: UNBLESS_KEY_LENGTH + 3,
                unbless_key_maxlength: UNBLESS_KEY_LENGTH
            };
        },
        onRender: function() {
            this.set_submit_state();
            this.ui.help.tooltip({
                delay: { show: 500, hide: 100 }
            });
        }
    });
    export default View;

